/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import { EstateSaleList, EstateSaleByCategory, PreviousNext, ItemView } from 'features/components/base/public';

/**
 * routing for Estate sale components
 * 
 * @param props
 * 
 * @return routing for Estate sale components
 * 
**/

export class EstateSalesRouter extends Component {

    render() {
        return (
            <Switch>
                <Route exact path={[`/estate-sale/list`,`/estate-sale/list/endingsoon`]} component={EstateSaleList} />
                <Route exact path={`/estate-sale/list/:filter`} component={EstateSaleList} />
                <Route exact path={[`/estate-sale/:saleId`, `/estate-sale-item/:saleId/item/:itemId`]} component={EstateSaleByCategory} />
                <Route exact path={[`/estate-sale/:saleId/item/:itemId`, `/estate-sale/:saleId/item/:itemId/:itemTitle`, `/estate-sale/:saleId/item/:itemId/:itemTitle/:fromWhichPath`]} component={ItemView} />
                <Redirect to="/" />
            </Switch>
        );
    }
}